import type { EnderecoBloqueado } from "../../../services/enderecosBloqueados"

export interface EnderecosBloqueadosModel {
    lista: EnderecoBloqueado[]
}

export const EnderecosBloqueadosInicial: EnderecosBloqueadosModel = {
    lista: [],
}
